import type { FC, ReactNode } from 'react'

import { Search, X } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Input } from '@/components/ui/input'

interface SearchInputProps {
    id: string
    value: string
    onChange: (value: string) => void
    placeholder: string
    label: string
    className?: string
}

const SearchInput: FC<SearchInputProps> = ({ id, value, onChange, placeholder, label, className }): ReactNode => {
    return (
        <div className={cn('relative min-w-0', className)}>
            <label htmlFor={id} className='sr-only'>
                {label}
            </label>

            <Search className='pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground' />

            <Input
                id={id}
                type='search'
                value={value}
                onChange={event => onChange(event.target.value)}
                placeholder={placeholder}
                className='h-10 bg-background pr-9 pl-9 [&::-webkit-search-cancel-button]:hidden'
            />

            {value && (
                <button
                    type='button'
                    onClick={() => onChange('')}
                    aria-label='Clear search'
                    className='absolute top-1/2 right-2 flex size-6 -translate-y-1/2 items-center justify-center rounded-md text-muted-foreground outline-none hover:bg-muted hover:text-foreground focus-visible:ring-3 focus-visible:ring-ring/40'
                >
                    <X className='size-4' />
                </button>
            )}
        </div>
    )
}

export default SearchInput
